import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98e751a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mark",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = {
  key: 0,
  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
}
const _hoisted_3 = {
  key: 1,
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}


export default /*#__PURE__*/_defineComponent({
  props: {
  isTick: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (props.isTick)
      ? (_openBlock(), _createElementBlock("path", _hoisted_2))
      : (_openBlock(), _createElementBlock("path", _hoisted_3))
  ]))
}
}

})